var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([2267,8382,1539].map(__webpack_require__.e, __webpack_require__)).then(next);
};